import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FiGrid, FiFileText, FiShoppingBag, FiMail, FiLogOut, FiMenu, FiX, FiExternalLink, FiImage, FiVideo, FiLayers, FiList, FiMessageSquare } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import { SITE } from "../utils/siteData";

const links = [
  { to: "/admin", label: "Dashboard", icon: <FiGrid />, end: true },
  { to: "/admin/services", label: "Services", icon: <FiLayers /> },
  { to: "/admin/other-services", label: "Other Pooja Services", icon: <FiList /> },
  { to: "/admin/blogs", label: "Blog Posts", icon: <FiFileText /> },
  { to: "/admin/products", label: "Marketplace Products", icon: <FiShoppingBag /> },
  { to: "/admin/gallery", label: "Photo Gallery", icon: <FiImage /> },
  { to: "/admin/videos", label: "Videos & Reviews", icon: <FiVideo /> },
  { to: "/admin/testimonials", label: "Testimonials", icon: <FiMessageSquare /> },
  { to: "/admin/messages", label: "Contact Messages", icon: <FiMail /> },
];

export default function AdminLayout() {
  const { username, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <aside
        className={`fixed lg:static z-40 inset-y-0 left-0 w-64 bg-maroon-900 text-gold-100 flex flex-col transform transition-transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="px-6 py-6 border-b border-gold-900/40">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gold-500 text-maroon-900 flex items-center justify-center font-heading">ॐ</div>
            <div>
              <p className="font-heading text-sm leading-tight">Admin Panel</p>
              <p className="text-xs text-gold-100/70">{SITE.name}</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-6 space-y-1">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-gold-500 text-maroon-900" : "text-gold-100/85 hover:bg-maroon-800"
                }`
              }
            >
              {link.icon} {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-gold-900/40 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-gold-100/85 hover:bg-maroon-800"
          >
            <FiExternalLink /> View Website
          </a>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-gold-100/85 hover:bg-maroon-800"
          >
            <FiLogOut /> Logout
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-gray-200 px-4 sm:px-8 py-4 flex items-center justify-between">
          <button className="lg:hidden text-xl text-maroon-800" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
          <p className="text-sm text-gray-500">Logged in as <span className="font-semibold text-maroon-800">{username}</span></p>
        </header>

        <main className="flex-1 p-4 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
